import React from 'react';

import AddressBlock from 'Components/AddressBlock';
import Footer from 'Components/Footer';
import Header from 'Components/Header';
import OurTeam from 'Components/OurTeam';
import WorkerKontakt from 'Components/WorkerKontakt';

export default function Contact() {
  return (
    <>
      <Header />
      <OurTeam bg='bgr' overlay='dark' />
      <WorkerKontakt bg='black__bgr' overlay='dark' />
      <AddressBlock bg='bgr' overlay='dark' />
      <Footer />
    </>
  );
}
